@if (profileField$ | async; as profileField) {
  @if (childDefinition$ | async; as childDefinition) {
    @switch (childDefinition?.Type) {
      @case (FieldType.EnumField) {
        @if (enumOptions$ | async; as enumOptions) {
          @if (enumOptions.length > 5) {
            <sh-form-multi-select
              [id]="profileField.FieldDefinition.FlatKey"
              [label]="profileField.DisplayLabel"
              [labelIcons]="labelIcons"
              [helpText]="profileField.Description"
              [options]="selectOptions$ | async"
              [multiple]="true"
              [control]="control$ | async"
              [errorMsg]="(errorMsg$ | async) || '' | translate"
              [canBeIndeterminate]="canBeIndeterminate"
              [indeterminateMsg]="'general.different-values' | translate"
              [multipleSelectedMsg]="'general.filter.multiple' | translate"
              [allSelectedMsg]="'general.filter.all' | translate"
              [searchPlaceholderMsg]="'ui.search' | translate"
              [noResultsFoundMsg]="'ui.no-results' | translate"
              [listCappedMsg]="'ui.capped-results' | translate"
              [search]="true"
              [disabledMsg]="disabledMessageKey | translate"
              (searchTerm)="onSearchTermChange($event)"
              >
              <ng-container [ngTemplateOutlet]="batchMode"></ng-container>
            </sh-form-multi-select>
          } @else {
            <sh-form-checkbox-list
              [id]="profileField.FieldDefinition.FlatKey"
              [control]="control$ | async"
              [label]="profileField.DisplayLabel"
              [labelIcons]="labelIcons"
              [helpText]="profileField.Description"
              [errorMsg]="(errorMsg$ | async) || '' | translate"
              [options]="enumOptions$ | async"
              [canBeIndeterminate]="canBeIndeterminate"
              [indeterminateMsg]="'general.different-values' | translate"
              [disabledMsg]="disabledMessageKey | translate"
              >
              <ng-container [ngTemplateOutlet]="batchMode"></ng-container>
            </sh-form-checkbox-list>
          }
        }
      }
      @default {
        <ng-container [ngTemplateOutlet]="defaultList"></ng-container>
      }
    }
    <ng-template #defaultList>
      <sh-form-list
        [id]="profileField.FieldDefinition.FlatKey"
        [control]="control$ | async"
        [label]="profileField.DisplayLabel"
        [labelIcons]="labelIcons"
        [fieldType]="childDefinition.Type"
        [helpText]="profileField.Description"
        [placeholderMsg]=""
        [duplicateErrorMsg]=""
        [errorMsg]="(errorMsg$ | async) || '' | translate"
        [canBeIndeterminate]="canBeIndeterminate"
        [indeterminateMsg]="'general.only-matching-values-shown' | translate"
        [disabledMsg]="disabledMessageKey | translate"
        [autocompleteFct]="autocompleteFct"
        >
        <ng-container [ngTemplateOutlet]="batchMode"></ng-container>
      </sh-form-list>
    </ng-template>
    <ng-template #batchMode>
      <ng-content></ng-content>
    </ng-template>
  }
}
